export default __webpack_public_path__ + "static/media/chevron-up.caf6544c.svg";